<template>
  <!-- App.vue -->

  <v-app :id="cId">
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-dialog
        v-model="attachmentDialog"
        max-width="80vw"
        persistent
        @input="saleEditItem = {}"
        v-if="saleEditItem.memberId !== undefined"
      >
        <v-card>
          <v-card-text>
            <img
              lazy-src="https://picsum.photos/id/11/10/6"
              v-if="saleEditItem.memberId !== undefined"
              :src="
                api_uri +
                '/public/customers/' +
                saleEditItem.custId +
                '/' +
                saleEditItem.memberId._id +
                '/' +
                saleEditItem.attachImageFile
              "
              style="width: 50%"
            />
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="info darken-1" @click="attachmentDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="productDialog"
        max-width="80vw"
        persistent
        @input="saleEditItem = {}"
      >
        <v-card>
          <v-card-text>
            <product-app
              v-bind:saleInfo="saleInfo"
              v-bind:member="member"
              @closeProduct="closeProduct"
            ></product-app>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="trackingDialog"
        max-width="80vw"
        persistent
        @input="saleEditItem = {}"
      >
        <v-card>
          <v-card-text>
            <tracking-code
              v-bind:trackingType="trackingType"
              v-bind:trackingInfo="trackingInfo"
              @updateSales="readSales"
              @closeTracking="closeTracking"
            ></tracking-code>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- delete sales dialog -->
      <v-dialog v-model="dialogDelete" max-width="30%">
        <v-card>
          <v-card-title class="headline"
            >ต้องการลบรายการขาย {{ saleEditItem.name }} ?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info darken-1" @click="closeDelete">ยกเลิก</v-btn>
            <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end delete sales -->
      <!-- delete dialog -->
      <v-dialog v-model="dialogDeleteOrder" max-width="600px">
        <v-card>
          <v-card-title class="headline">ต้องการลบรายการสินค้า ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="dialogDeleteOrder = !dialogDeleteOrder"
              >Cancel</v-btn
            >
            <v-btn color="success" @click="deleteOrderConfirm">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end delete redeem point  -->

      <!-- attachment dialog -->
      <v-dialog v-model="dialogAttachment" max-width="600px">
        <v-card>
          <v-card-title class="headline">รูปแสดงใบเสร็จรับเงิน</v-card-title>
          <v-card-text>
            <v-img></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="dialogAttachment = !dialogAttachment"
              >ปิด</v-btn
            >

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end delete redeem point  -->

      <!-- add/edit sales -->
      <v-navigation-drawer
        :stateless="dialog"
        v-model="dialog"
        temporary
        right
        app
        width="480px"
      >
        <v-card>
          <v-card-title>
            <v-icon @click="close">mdi-close-circle</v-icon>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="saleEditItem.dealname"
                    label="รายการ"
                    aria-required="required"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-menu
                    ref="sales_date"
                    v-model="sales_date"
                    :close-on-content-click="false"
                    :return-value.sync="saleEditItem.sales_date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="saleEditItem.sales_date"
                        label="วันที่ขาย"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required="required"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="saleEditItem.sales_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="sales_date = false"> Cancel </v-btn>
                      <v-btn
                        color="success"
                        @click="$refs.sales_date.save(saleEditItem.sales_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-combobox
                    v-model="saleEditItem.member"
                    :items="memberList"
                    :loading="isLoading"
                    :search-input.sync="searchClient"
                    item-text="name"
                    item-value="name"
                    label="ชื่อลูกค้า"
                    placeholder="กรอกชื่อ นามสกุล"
                    prepend-icon="mdi-database-search"
                    return-object
                  ></v-combobox>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="ชื่อ-นามสกุล (จัดส่ง)"
                    v-model="saleEditItem.shipping_name"
                    item-text="name"
                    item-value="_id"
                    required="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="saleEditItem.shipping_phone"
                    label="เบอร์โทรศัพท์"
                    aria-required="required"
                    maxlength="10"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="saleEditItem.address"
                    label="ที่อยู่  (จัดส่ง)"
                    aria-required="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-combobox
                    v-model="saleEditItem.province"
                    :items="provinceList"
                    :loading="isLoading"
                    item-text="provinceThai"
                    item-value="provinceThai"
                    label="จังหวัด"
                    placeholder="จังหวัด"
                    :return-object="returnObject"
                  >
                  </v-combobox>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-combobox
                    v-model="saleEditItem.zipcode"
                    :items="postCode"
                    :loading="isLoading"
                    item-text="postcode"
                    item-value="postcode"
                    label="รหัสไปรษณีย์"
                    placeholder="กรอกรหัสไปรษณีย์"
                    prepend-icon="mdi-database-search"
                    :return-object="returnObject"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" @click="close"> ยกเลิก</v-btn>
            <v-btn tile color="success" @click="saleSave"> ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>
      <div style="text-align: center; padding-left: 30% !important" width="100%">
        <v-alert
          v-if="responseStatus.alertStatus"
          :type="responseStatus.type"
          width="40%"
          style="z-index: 9999; text-align: left"
          dense
          dismissible
          @input="responseStatus.alertStatus = !responseStatus.alertStatus"
        >
          {{ responseStatus.text }}
        </v-alert>
      </div>

      <v-card app>
        <v-card-title>
          รายการขาย {{ name }}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-toolbar flat>
            <v-spacer></v-spacer>

            <v-btn color="success" dark class="mb-2" @click="editItem">
              <v-icon left>mdi-plus</v-icon> เพิ่มรายการขาย
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="headers"
            :items="sales"
            :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }"
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
          >
            <template v-slot:item.sales_date="{ item }">
              {{ item.sales_date.substring(0, 10) | formatThDate }}
              <!--{{ item.sales_date.substring(11, 19) }}-->
            </template>

            <template v-slot:item.name="{ item }">
              {{ item.firstname }} {{ item.lastname }}
            </template>

            <!-- <template v-slot:item.productList="{ item }"> </template> -->

            <template v-slot:item.discount="{ item }">
              <div>{{ item.discount | numFormat("0,000,000.00") }}</div>
            </template>

            <template v-slot:item.amount="{ item }">
              <div>{{ item.amount | numFormat("0,000,000.00") }}</div>
            </template>

            <template v-slot:item.order_history="{ item }">
              <v-icon @click="viewsales(item)" @click.stop="drawerOrder = !drawerOrder"
                >mdi-cart-check</v-icon
              >
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                @click="viewProducts(item)"
                :color="item.status == 'Completed' ? 'green' : 'red'"
                v-if="item.status != 'Canceled'"
                >mdi-cart-check</v-icon
              >
              <v-icon
                @click="tracking(item)"
                v-if="item.status == 'Completed'"
                :color="item.tracking_information !== undefined ? 'green' : 'red'"
                >mdi-truck-fast-outline</v-icon
              >
              <v-icon
                @click="attachment(item)"
                title="Bill / Recieved"
                color="red"
                v-if="item.attachImageFile !== undefined"
                >mdi-attachment</v-icon
              >
              <v-icon
                class="mr-2"
                @click="editItem(item)"
                v-if="item.status != 'Canceled'"
              >
                mdi-pencil
              </v-icon>
              <v-icon @click="deleteItem(item)" v-if="item.status != 'Canceled'">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              <!--v-btn color="primary" @click="readSales"> Reset </v-btn-->
            </template>
          </v-data-table>

          <!-- end add/edit sales -->
        </v-card-text>
        <v-card-actions>
          <download-excel
            :data="excelExport"
            worksheet="รายการแลกของรางวัล"
            name="รายการแลกของรางวัล.xls"
          >
            <v-icon color="success darken-1" x-large style="cursor: pointer"
              >mdi-microsoft-excel</v-icon
            >
          </download-excel>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
//import _ from "underscore";
import { validationMixin } from "vuelidate";
//import { required, minLength } from "vuelidate/lib/validators";
import JsonExcel from "vue-json-excel";
import productList from "../sale-products/sale-product.vue";
import trackingCode from "../tracking-code/tracking-code.vue";

//import  summary   from "../../../library/functions.js";

//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";

export default {
  name: "SalesList",

  props: {
    filterMember: {
      type: Object,
    },
    cId: {
      type: String,
    },
  },

  components: {
    "product-app": productList,
    "tracking-code": trackingCode,
    downloadExcel: JsonExcel,
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
  },
  mixins: [validationMixin],
  validations: {
    saleEditItem: {
      memberId: {
        _id: "",
      },
      attachImageFile: "",
    },
  },
  data() {
    return {
      //cId: "",
      name: "",
      member: {},
      //memberInfo:{},
      returnObject: false,
      attachmentDialog: false,
      trackingItem: {},
      //memberInfo: {},
      sales_date: "",
      saleInfo: {},
      trackingInfo: {},
      nameSelect: "",
      drawer: null,
      drawerOrder: null,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      dialogDeleteOrder: false,
      dialogAttachment: false,
      select: "",
      saleAutoCompleted: {},
      trackingType: "Order",
      saleEditItem: {
        name: {},
        province: "",
        postcode: "",
      },
      postcodeList: [],
      productDialog: false,
      trackingDialog: false,
      //provinceList: [],
      ampherList: [],
      tambonList: [],
      //postCode:[],
      isLoading: false,
      orderHistory: {},
      productList: [],
      addList: {},
      memberList: [],
      responseStatus: {
        alertStatus: false,
      },
      show: false,
      defaultItem: {},
      deleteIndex: -1,
      editedIndex: -1,
      edit: false,
      search: "",
      payload: {},
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      totalItems: 0,
      options: { sortBy: "createdAt", sortDesc: true },
      //sales: [],
      items_status: ["Draft", "Active", "Inactive"],
      searchClient: null,
      headers: [
        {
          value: "hubspot_id",
          text: "No.",
        },
        {
          value: "sales_date",
          text: "วันที่ขาย",
        },

        {
          value: "dealname",
          text: "รายการ",
        },
        {
          value: "name",
          text: "ลูกค้า", // this.$t("tables.headings.status")
        },

        // {
        //   value: "productList",
        //   text: "รายการสินค้า", // this.$t("tables.headings.status")
        // },
        {
          value: "sumDiscount",
          text: "ส่วนลด (บาท)", // this.$t("tables.headings.amount")
        },

        {
          value: "amount",
          text: "ยอดขาย (บาท)", // this.$t("tables.headings.amount")
        },
        {
          value: "point",
          text: "คะแนน", // this.$t("tables.headings.amount")
        },
        {
          value: "status",
          text: "สถานะ", // this.$t("tables.headings.quantity")
        },
        {
          value: "actions",
          text: "Actions", // this.$t("tables.headings.actions")
        },
      ],
    };
  },
  created() {
    //this.searchAddressDataAutoComplete();
  },
  computed: {
    /*
    phoneError() {
      const errors = [];
      //alert(this.memberInfo.phone);
      if (!this.$v.saleEditItem.phone.$dirty && !this.edit) return errors;
      !/(^0)(2|3|4|5|6|7|8|9)[0-9]{8,8}/.test(this.saleEditItem.phone) &&
        errors.push("เบอร์โทรศัพท์ไม่ถูกต้อง ");
      !this.$v.saleEditItem.phone.required && errors.push("กรุณากรอกเบอร์โทรศัพท์");
      return errors;
    },
    */

    // phone2Error() {
    //   const errors = [];
    //   if (!this.$v.saleEditItem.phone_2.$dirty && !this.edit) return errors;
    //   !/(^0)(6|8|9)[0-9]{8,8}/.test(this.saleEditItem.phone_2) &&
    //     errors.push("เบอร์โทรศัพท์ไม่ถูกต้อง ");
    //   return errors;
    // },

    provinceList() {
      let tmp = [];
      let result = this.postcodeList
        .map((item) => {
          if (this.saleEditItem.province != "") {
            if (
              item.provinceThai.indexOf(this.saleEditItem.province) == -1 &&
              tmp.indexOf(item.provinceThai) == -1
            ) {
              tmp.push(item.provinceThai);
              return { provinceThai: item.provinceThai };
            }
          } else {
            if (tmp.indexOf(item.provinceThai) == -1) {
              tmp.push(item.provinceThai);
              //tmpProvince = item.provinceThai;
              return { provinceThai: item.provinceThai };
            }
            // return item.provinceThai;
          }
        })
        .filter((items) => {
          return items !== undefined;
        });
      //console.log(result);
      return result;
    },
    postCode() {
      // console.log(this.postcodeList);
      // console.log(this.saleEditItem.province);
      // console.log(this.saleEditItem.postcode);
      let tmp = [];
      // let tmpPostCode ="";
      //console.log(tmp);
      let result = this.postcodeList
        .map((item) => {
          // //console.log(item);
          if (
            this.saleEditItem.postcode != "" &&
            this.saleEditItem.postcode !== undefined
          ) {
            if (
              item.provinceThai == this.saleEditItem.province &&
              tmp.indexOf(item.postcode) == -1 &&
              item.postcode.indexOf(this.saleEditItem.postcode) > -1
            ) {
              //console.log("1");
              tmp.push(item.postcode);
              return { postcode: item.postcode };
            }
          } else {
            //console.log(3);
            if (
              tmp.indexOf(item.postcode) == -1 &&
              item.provinceThai == this.saleEditItem.province
            ) {
              //console.log(2);
              tmp.push(item.postcode);
              return { postcode: item.postcode };
            }
          }
        })
        .filter((item) => {
          return item !== undefined;
        });
      //console.log(result);
      return result;
    },
    salesFilter() {
      if (this.search.length > 0) {
        return this.sales.filter(() => {
          // this.readSales().then((response) => {
          //   this.sales = response.data;
          //   this.totalItems = response.totalItems;
          // });
        });
      } else {
        return this.sales;
      }
    },

    formTitle() {
      return this.editedIndex === -1 ? "บันทึกรายการขายใหม่" : "แก้ไขรายการขายใหม่";
    },
    excelExport() {
      return this.sales.map((item) => {
        return {
          DealId: item.hubspot_id,
          Date: this.$options.filters.formatThDate(item.sales_date.substring(0, 10)),
          OrderList: item.dealname,
          Member: item.firstname + " " + item.lastname,
          Discount: item.discount || 0,
          Amount: item.amount,
          Point: item.point || 0,
          Status: item.status,
        };
      });
    },
    sales() {
      ////console.log("sales");
      ////console.log(this.$store.state.salesList);
      console.log(this.filterMember);
      return this.$store.state.salesList.filter((item) => {
        // console.log(item.memberId._id + "    " + this.filterMember._id);
        // console.log(item);
        // if (this.filterMember._id !== undefined) {
        //   //
        //   return item.memberId._id == this.filterMember._id;
        // } else {
        return (
          item.dealname.toLowerCase().indexOf(this.search) > -1 ||
          item.firstname.toLowerCase().indexOf(this.search) > -1 ||
          item.lastname.toLowerCase().indexOf(this.search) > -1 ||
          item.phone.toLowerCase().indexOf(this.search) > -1
        );
        //}
      });
    },
  },
  mounted() {
    //console.log(this.provinceList);
    ////console.log("mounted");
    // this.saleEditItem = this.memberInfo;
    //this.memberInfo.name = this.memberInfo.firstname + " " + this.memberInfo.lastname;

    this.$store.dispatch("resetSalesList");
    console.log(this.cId);
    this.cId = new Date().getTime().toString();
    console.log(this.cId);
    //
    this.searchAddressDataAutoComplete();
    this.readSales(); /* .then((response) => {
      if (response.data.length > 0) {
        this.$store.dispatch("setSalesList", response.data);
        this.totalItems = response.totalItems;
      }
    }); */
  },
  methods: {
    async memberInfo() {
      console.log(this.saleInfo);
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          apiKey: sessionStorage.getItem("apiKey"),
          id: this.saleInfo.memberId._id,
        };
        await axios
          .get(
            this.api_uri + "/v1/clients/get/" + this.payload.id,
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
                custId: sessionStorage.getItem("custId"),
              },
            }
          )
          .then((response) => {
            console.log(response);
            this.member = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (err) {
        console.log(err);
      }
    },
    closeProduct() {
      this.productDialog = false;
    },
    closeTracking() {
      this.trackingDialog = false;
    },

    attachment(item) {
      //console.log(item);
      this.saleEditItem = item;
      this.attachmentDialog = true;
    },
    closeSaleDialog() {
      //console.log("closeSaleDialog");
      this.$emit("closeSaleDialog", "");
    },
    // async saveSaleProduct() {
    //   //update sale db / hubspot
    //   //const url = process.env.VUE_APP_LOYALTY_API_URI;
    //   //this.api_uri + //console.log(url);
    //   let payload = {
    //     sales: this.$store.state.sales,
    //     apiKey: sessionStorage.getItem("apiKey"),
    //     updatedBy: sessionStorage.getItem("email"),
    //     custId: sessionStorage.getItem("custId"),
    //     "token": sessionStorage.getItem("token"),
    //   };
    //   await axios
    //     .put(this.api_uri + "/v1/sales/update-sale-product", payload, {
    //       headers: {
    //         // Overwrite Axios's automatically set Content-Type
    //         "Content-Type": "application/json",
    //         "token": sessionStorage.getItem("token"),
    //       },
    //     })
    //     .then((response) => {
    //       //
    //       //console.log("update - sale - product");
    //       //console.log(response);
    //       if (response.data.code == 0) {
    //         this.$store.dispatch("updateSalesStatus", "Completed");
    //         this.responseStatus = {
    //           status: "Success",
    //           code: 0,
    //           color: "green",
    //           type: "success",
    //           text: "บันทึกสำเร็จ",
    //           alertStatus: true,
    //         };
    //         //console.log(this.responseStatus);
    //       }
    //     })

    //     .catch((err) => {
    //       this.responseStatus = {
    //         status: "Error",
    //         code: 500,
    //         message: err,
    //       };
    //     });
    // },
    filterDistrict(zipcode) {
      let dupDistrict = "";
      this.ampherList = [];
      this.tambonList = [];
      return this.postcodeList
        .filter((item) => {
          return item.postcode == zipcode;
        })
        .map((item) => {
          if (item.districtThaiShort !== dupDistrict) {
            this.ampherList.push({ districtThaiShort: item.districtThaiShort });
            dupDistrict = item.districtThaiShort;
          }
        });
    },

    filterTambon(zipcode, district) {
      this.tambonList = [];
      this.saleEditItem.tambon = "";
      return this.postcodeList
        .filter((item) => {
          return item.postcode == zipcode;
        })
        .map((item) => {
          if (item.districtThaiShort == district) {
            this.tambonList.push({ tambonThaiShort: item.tambonThaiShort });
          }
        });
    },

    changeDistrict() {
      this.tambonList = [];
      this.filterTambon(
        this.saleEditItem.zipcode.postcode,
        this.saleEditItem.district.districtThaiShort
      );
    },

    readSales() {
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      // this.searchAddressDataAutoComplete();
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          //memberId: this.memberInfo._id,
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        return axios
          .get(
            this.api_uri + "/v1/sales/list",
            { params: this.payload }, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //return response.data;
            // if (response.data.data.length > 0) {
            //   this.$store.dispatch("setSalesList", response.data.data);
            //   this.totalItems = response.totalItems;
            // }
            if (this.filterMember !== undefined) {
              let saleList = response.data.data.filter((item) => {
                return item.memberId._id == this.filterMember._id;
              });
              this.$store.dispatch("setSalesList", saleList);
              this.totalItems = saleList.length;
            } else {
              this.$store.dispatch("setSalesList", response.data.data);
              this.totalItems = response.totalItems;
            }
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
      this.isLoading = true;
    },
    resetInput() {
      //console.log("input reset");
      this.saleEditItem = {};
    },

    viewProducts(item) {
      //console.log(item);
      this.$store.dispatch("resetSalesProduct");

      this.saleInfo = item;
      this.memberInfo(); ////console.log(this.saleInfo);
      this.$store.dispatch("setSales", item);
      this.$store.state.saleProduct = this.saleInfo.products || [];
      this.productDialog = true;
    },

    tracking(item) {
      ////console.log(item);
      this.$store.dispatch("resetSales");
      this.trackingDialog = true;
      this.$store.dispatch("setSales", item);
      this.trackingItem = item;
      this.trackingInfo = item;
      ////console.log(this.$store.state.sales);
    },
    // get product
    async getProductBySKU() {
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
        };
        axios
          .post(
            this.api_uri + "/v1/products/getProductBySKU/" + this.addList.sku,
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            this.addList = { ...response.data[0] };
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },
    async searchAddressDataAutoComplete() {
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      this.isLoading = true;
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          type: "postcode",
          filter: "",
        };
        axios
          .post(
            this.api_uri + "/v1/zipcode/getZipcodeData",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            ////console.log(response.data);
            this.postcodeList = response.data;
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
      console.log(this.postcodeList);
      this.isLoading = false;
    },
    async searchClientAutoComplete(val) {
      ////console.log("auto Completed");
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      this.isLoading = true;
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          filter: val,
        };
        axios
          .post(
            this.api_uri + "/v1/clients/getClientByFilter",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            console.log(response);
            this.memberList = response.data.map((item) => ({
              _id: item._id,
              name: item.firstname + " " + item.lastname,
              phone: item.phone,
            }));
            ////console.log(this.memberList);
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
      this.isLoading = false;
    },
    async getClientByPhone() {
      //const url = process.env.VUE_APP_LOYALTY_API_URI;

      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          phone: this.saleEditItem.phone,
        };
        axios
          .post(
            this.api_uri + "/v1/clients/getClientByPhone",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            this.memberList = response.data.map((item) => ({
              _id: item._id,
              name: item.firstname + " " + item.lastname,
            }));
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },

    // Order
    viewsales(item) {
      this.orderHistory = item;
      this.editedIndex = item._id;
    },

    addProduct() {
      let product = {
        sku: this.addList.sku,
        name: this.addList.name,
        quantity: this.addList.quantity,
        price: this.addList.price,
        amount: this.addList.amount,
      };
      this.productList.push(product);
    },
    /*
    async addOrder() {
      if (this.editedIndex > -1) {
        //console.log("update");
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payload = {
createdBy: sessionStorage.getItem("email"),
        updatedBy: sessionStorage.getItem("email"),
custId: sessionStorage.getItem("custId"),


            //...this.saleEditItem,
            //image: this.image,
            id: this.orderHistory._id,
          };
          //console.log(this.payload);
          await axios
            .put(
              this.api_uri + "/v1/sales/updateorderHistory",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
"token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              this.resetInput();
            });
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      } else {
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payload = {
createdBy: sessionStorage.getItem("email"),
        updatedBy: sessionStorage.getItem("email"),
custId: sessionStorage.getItem("custId"),


            id: this.orderHistory._id,
            order_history: [
              ...this.orderHistory.order_history,
              {
                //
              },
            ],
          };
          await axios
            .post(
              this.api_uri + "/v1/sales/updateorderHistory",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
"token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };

              this.orderHistory.order_history = [
                ...this.orderHistory.order_history,
                {
                  //
                },
              ];
              this.resetInput();
            })
            .catch((error) => {
              //console.log(error);
            });
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      }
    },
    */
    /*
    deleteProduct(item) {
      //console.log(item);
      this.deleteIndex = this.productList.indexOf(item);
      this.dialogDeleteProduct = true;
    },
*/
    deleteOrder(item) {
      this.deleteIndex = this.productList.indexOf(item);
      //console.log("deleteOrder");
      //console.log(item);
      //console.log(this.deleteIndex);
      this.dialogDeleteOrder = true;
    },
    async deleteOrderConfirm() {
      this.dialogDeleteOrder = !this.dialogDeleteOrder;

      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          //
        };

        const response = await axios.post(
          this.api_uri + "/v1/sales/deleteOrderHistory/" + this.orderHistory._id,
          this.payload
        );
        console.log(response);

        if (response.data.n == response.data.nModified > 0) {
          this.responseStatus = {
            status: "Success",
            code: 0,
            color: "green",
            type: "success",
            text: "บันทึกสำเร็จ",
            alertStatus: true,
          };
          //this.productList.splice(this.deleteIndex, 1);
          //console.log("removeSalesList");
          //console.log(this.deleteIndex);
          //this.$store.dispatch("removeSalesList", this.deleteIndex);
          //this.$store.dispatch("resetSalesList");
          //
          this.$store.dispatch("resetSalesList");
          this.readSales();
          this.resetInput();
        } else {
          this.responseStatus = {
            status: "Error",
            code: 8001,
            color: "red",
            type: "error",
            text: "ล้มเหลว",
            alertStatus: true,
          };
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }
    },
    editItem(item) {
      console.log("editItem")
      console.log(item);
      if (typeof item._id !== "undefined") {
        
        this.member = item.memberId

        this.editedIndex = this.sales.indexOf(item);
        item.sales_date = item.sales_date.substring(0, 10);
        this.saleEditItem = {
          ...item,
          address: item.shipping_address,
          province: item.shipping_province,
          zipcode: item.shipping_postcode,

          //zipcode: item.postcode,
          member: {
            _id: item.member,
            name: item.firstname + " " + item.lastname,
          },
          memberId: this.member._id
        };
        //console.log(this.saleEditItem);
      } else {
        Object.assign({}, this.saleEditItem);
      }
      console.log(this.saleEditItem);
      this.edit = this.editedIndex !== -1 ? true : false;
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.sales.indexOf(item);
      this.saleEditItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.productList.splice(this.editedIndex, 1);
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        const response = await axios.delete(
          this.api_uri +
            "/v1/sales/delete/" +
            this.saleEditItem._id +
            "?apiKey=" +
            sessionStorage.getItem("apiKey"),
          {
            headers: {
              "token": sessionStorage.getItem("token"),
            },
            data: {
              //
            },
          }
        );
        //console.log(response);

        if (response.data.n == response.data.deletedCount > 0) {
          this.responseStatus = {
            status: "Success",
            code: 0,
            color: "green",
            type: "success",
            text: "บันทึกสำเร็จ",
            alertStatus: true,
          };
          //this.sales.splice(this.editedIndex, 1);
          this.$store.dispatch("removeSalesList", this.deleteIndex);
          this.$store.dispatch("resetSalesList");
          //
          this.readSales();
        } else {
          this.responseStatus = {
            status: "Error",
            code: 8001,
            color: "red",
            type: "error",
            text: "ล้มเหลว",
            alertStatus: true,
          };
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }

      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.edit = false;
      // this.$nextTick(() => {
      //this.saleEditItem = Object.assign({}, { name: {} });
      this.saleEditItem = {};
      this.editedIndex = -1;
      // });
    },
    closeDelete() {
      this.dialogDelete = false;
      // this.$nextTick(() => {
      //   this.saleEditItem = Object.assign({}, { name: {} });
      //   this.editedIndex = -1;
      // });
    },
    // timeout close overlay
    closeInTime(sec) {
      //console.log("closeInTimes");
      //console.log(sec);
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    async saleSave() {
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      //console.log("Save Sale");
      // this.saleEditItem.member =
      //   typeof this.saleEditItem.member._id !== undefined
      //     ? this.saleEditItem.member
      //     : { _id: null, name: this.nameSelect };
      let _item = this.saleEditItem;
      _item.custId = sessionStorage.getItem("custId");
      let _edited;

      if (this.editedIndex > -1) {
        try {
          this.payload = {
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),
            member: this.member,
            dealname: _item.dealname,
            sales_date: _item.sales_date,
            amount: _item.amount || 0.0,
            discount: _item.discount || 0.0,
            phone: _item.phone || "",
            phone_2: _item.phone_2 || "",
            // postcode: _item.zipcode.postcode || _item.postcode,
            // tambon: _item.tambon.tambonThaiShort || _item.tambon,
            // district: _item.district.districtThaiShort || _item.district,
            // province: _item.province.provinceThai || _item.province,
            id: _item._id,
            point: _item.point,
            hubspot_id: _item.hubspot_id,
            //address: _item.address || "",
            // member: _item.member.name || "",
            shipping_address: {
              name: _item.shipping_name,
              phone: _item.shipping_phone,
              address: _item.address,
              state: _item.province,
              postcode: _item.zipcode,
            },
            memberId: this.member._id,
            status: _item.status,
          };
          await axios
            .put(
              this.api_uri + "/v1/sales/update",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              _edited = response.data;
            });
          if (_edited.nModified == 1) {
            Object.assign(this.sales[this.editedIndex], this.saleEditItem);
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
            };
            this.$store.dispatch("resetSalesList");
            this.readSales();
            this.dialog = false;
          } else {
            this.responseStatus = {
              status: "Error",
              code: 500,
              color: "red",
              type: "error",
              text: "อัพเดตไม่บันทึกสำเร็จ",
              alertStatus: true,
            };
          }
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      } else {
        try {
          this.payload = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),
            dealname: _item.dealname,
            sales_date: _item.sales_date,
            amount: _item.amount || 0.0,
            discount: _item.discount || 0.0,
            phone: _item.phone || "",
            phone_2: _item.phone_2 || "",
            shipping_address: {
              name: _item.shipping_name,
              phone: _item.shipping_phone,
              address: _item.address,
              state: _item.province,
              postcode: _item.zipcode,
            },
            // postcode: _item.zipcode.postcode,
            // tambon: _item.tambon.tambonThaiShort,
            // district: _item.district.districtThaiShort,
            // province: _item.province.provinceThai,
            id: null,
            //address: _item.address || "",
            member: _item.member,
            memberId: _item.member._id,
            status: "Pending",
          };
          await axios
            .post(
              this.api_uri + "/v1/sales/create",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              if (response.data.code == 0) {
                this.responseStatus = {
                  status: "Success",
                  code: 0,
                  color: "green",
                  type: "success",
                  text: "บันทึกสำเร็จ",
                  alertStatus: true,
                  //data: response.data,
                };
                this.totalItems++;
                this.dialog = false;
              }
              this.$store.dispatch("resetSalesList");
              this.readSales();
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      }

      //console.log("saved");
    },
  },

  watch: {
    options: {
      handler() {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
        };

        // this.readSales().then((response) => {
        //   this.sales = response.data;
        //   this.totalItems = response.totalItems;
        // });
      },
      deep: true,
    },
    /*
    search: {
      handler(val) {
        if (val.length >= 3) {
          // this.readSales().then((response) => {
          //   this.sales = response.data;
          //   this.totalItems = response.totalItems;
          // });
        }
      },
    },
  */
    saleEditItem: {
      handler(val) {
        console.log(val);
        //console.log("saleEditItem");
        console.log(this.saleEditItem);
      },
    },

    searchClient(val) {
      console.log("searchClient");
      console.log(val);
      if (typeof val === "string" && val.length >= 3) {
        this.saleEditItem.name = Object.assign({}, { _id: null, name: val });
        this.nameSelect = val;
        val && val !== this.saleEditItem.name && this.searchClientAutoComplete(val);
      }
      //console.log(this.saleEditItem);
    },
    dialog(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
    cId(val) {
      console.log(val);
      console.log(this.filterMember);
      if (this.filterMember._id !== undefined) {
        this.saleEditItem = this.filterMember;

        this.searchClient =
          this.filterMember.firstname + " " + this.filterMember.lastname;
        this.name = this.searchClient;
        this.nameSelect = {
          name: this.name,
          phone: this.filterMember.phone,
          _id: this.filterMember._id,
        };
        this.saleEditItem.member = this.nameSelect;
      }
      console.log(this.saleEditItem);
    },
    /*
    totalItems: {
      handler(newVal, oldVal) {
        if (oldVal != null && newVal != "undefined") {
          // this.readSales().then((response) => {
          //   this.sales = response.data;
          //   this.totalItems = response.totalItems;
          // });
        }
      },
    },
    */
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          //alert(this.responseStatus.alertStatus);
          this.closeInTime(this.closeInSec);
          //this.responseStatus.alertStatus = false;
        }
      },
    },
  },
};
</script>
<style scoped type="css">
.width-60 {
  width: 60% !important;
  display: flex;
}

/deep/ .v-text-field__slot input {
  text-align: right !important;
}
</style>
